import { graphql } from "@/lib/gql/__generated__";

export const SEND_SAMPLE_EMAIL_RESERVATION_CIN_MUTATION = graphql(`
	mutation TestEmailReservationCin($input: TestEmailInput!) {
		testEmailReservationCin(input: $input) {
			userErrors
			status
		}
	}
`);
